import { Component } from 'react'
import HomeIcon from 'material-ui/svg-icons/action/home'
import Fetch from 'utils/fetch'
import Loading from 'components/center-loading'
import HeaderIcon from 'components/header-icon'
import BusinessUnitList from './business-unit-list'
import BusinessUnitForm from './business-unit-form'
import ButtonNewItem from 'components/button-new-item'
import intl from 'react-intl-universal'

import './business-unit.css'
import { profileAdminOrMasterData } from 'services/permissions/getPermissions'

import Sidebar from 'components/sidebar'
import ButtonIcon from 'components/button-icon'
import { IconFilterActive } from 'components/icons/icn-filter-active.icon'
import { IconFilterInactive } from 'components/icons/icn-filter-inactive.icon'
import IconEmpty from 'images/iconEmpty.icon'
import { generateQueryParams } from 'utils/custom-functions'
import BusinessUnitFilter from 'components/filters/filter-business-unit'
import StorePersist from 'utils/store-persist'
import DeleteDialog from 'components/delete-dialog'
import SnackBar from 'material-ui/Snackbar'

class BusinessUnit extends Component {
  constructor() {
    super()

    const stored = StorePersist.getValuesJSON('filtersBusinessUnit')
    const defaultFilters = {
      Nome: null,
      SupplierId: null,
      Destino: '',
      TipoUnidadeEnumValue: null,
      Pais: null,
      StatusEnumValue: null,
    }

    this.state = {
      isFetching: false,
      openEditMode: false,
      unities: [],
      total: 0,
      currentPage: 0,
      openForm: false,
      idSelected: 0,

      showFeedback: false,
      messageFeedBack: '',
      typeFeedback: 'warning',

      qtRegsPerPage: 50,
      showMsg: false,
      textMsg: '',

      openDelete: false,
      deleteErrorDetail: '',

      showFilterBusinessUnit: false,
      filters: stored ?? defaultFilters,
    }
  }

  componentDidMount() {
    const stored = StorePersist.getValuesJSON('filtersBusinessUnit')
    if (stored) this.setState({ filters: stored })
  }

  showMessage = (message) => this.setState({ showMsg: true, textMsg: message })

  showFeedback = (message, type = 'warning') =>
    this.setState({ showFeedback: true, messageFeedBack: message, typeFeedback: type })

  closeFeedback = () => this.setState({ showFeedback: false })

  openNewForm = () => this.setState({ openEditMode: false, idSelected: 0, openForm: true })

  openEditForm = (row) => {
    const { unities } = this.state
    const selectedItem = unities[row]
    this.setState({ openEditMode: true, idSelected: selectedItem.Id, openForm: true })
  }

  closeForm = () => this.setState({ openForm: false })

  openDelete = (id) => this.setState({ openDelete: true, idSelected: id, deleteErrorDetail: '' })

  closeDelete = () => this.setState({ openDelete: false, deleteErrorDetail: '' })

  extractApiDetail = (ex) => {
    const d = ex?.response?.data
    const detail = d?.Errors?.[0]?.Detail || d?.Message || d?.error?.message || ex?.message
    return detail || intl.get('stocks.timeline.feedback.serverError')
  }

  deleteBusinessUnit = () => {
    const id = this.state.idSelected
    this.startFetching()

    Fetch.delete(`business-units/${id}`)
      .then(() => this.closeDelete())
      .then(() => this.searchUnities(this.state.currentPage))
      .then(() =>
        this.showFeedback(
          intl.get('master-data.managementUnity.unitys.feedback.disabledSuccessfully')
        )
      )
      .catch((e) => {
        const detail = this.extractApiDetail(e)
        this.setState({ deleteErrorDetail: detail, openDelete: true, showFeedback: true })
      })
      .finally(() => this.stopFetching())
  }

  startFetching = () => this.setState({ isFetching: true })
  stopFetching = () => this.setState({ isFetching: false })

  proccessErro = (ex) => {
    this.showMessage(
      ex.response?.status === 400
        ? ex.response.data.Message
        : intl.get('stocks.timeline.feedback.serverError')
    )
  }

  refreshSearch = () => {
    this.closeForm()
    this.searchUnities(this.state.currentPage)
  }

  searchUnities = (page = 0) => {
    this.startFetching()
    const { qtRegsPerPage, filters } = this.state

    const filterQuery = generateQueryParams({
      Nome: filters.Nome || null,
      SupplierId: filters.SupplierId,
      Destino: (filters.Destino || '').trim() || null,
      TipoUnidadeEnumValue: filters.TipoUnidadeEnumValue,
      Pais: filters.Pais,
      StatusEnumValue: filters.StatusEnumValue,
    })

    const base = '/business-units:paginated'
    const qsParts = [`CountPage=${qtRegsPerPage}`, `Page=${page}`]
    if (filterQuery) qsParts.push(filterQuery)

    const url = `${base}?${qsParts.join('&')}`

    Fetch.get(url)
      .then((response) => this.proccessData(response.data))
      .then(() => this.setState({ currentPage: page }))
      .catch((e) => this.proccessErro(e))
      .finally(() => this.stopFetching())
  }

  proccessData = (data) => this.setState({ unities: data.Data, total: data.TotalRecordCount })

  toggleFilter = () =>
    this.setState((prev) => ({ showFilterBusinessUnit: !prev.showFilterBusinessUnit }))

  applyFilters = (filters) => {
    StorePersist.setValuesJSON('filtersBusinessUnit', filters)
    this.setState({ filters, currentPage: 0, showFilterBusinessUnit: false }, () =>
      this.searchUnities(0)
    )
  }

  hasActiveFilter = () => {
    const { filters } = this.state
    return Boolean(
      (filters.Nome && String(filters.Nome).trim() !== '') ||
        (filters.Destino && String(filters.Destino).trim() !== '') ||
        filters.SupplierId != null ||
        filters.TipoUnidadeEnumValue != null ||
        filters.Pais != null ||
        filters.StatusEnumValue != null
    )
  }

  render() {
    const {
      openForm,
      idSelected,
      unities,
      total,
      showFeedback,
      isFetching,
      openEditMode,
      showFilterBusinessUnit,
      filters,
      openDelete,
      deleteErrorDetail,
    } = this.state

    return (
      <div className='unities-list-container'>
        <Loading isLoading={isFetching} />

        <div className='unities-header'>
          <HeaderIcon
            title={intl.get('master-data.managementUnity.unitys.header.title')}
            subtitle={intl.get('master-data.managementUnity.unitys.header.subtitle')}
            icon={<HomeIcon style={{ width: 45, height: 45 }} color='var(--color-brand-500)' />}
          />

          <div
            className='unities-header__actions'
            style={{ display: 'flex', gap: 12, alignItems: 'center' }}
          >
            {profileAdminOrMasterData() && (
              <div title={intl.get('master-data.managementUnity.unitys.actions.newManagementUnity')}>
                <ButtonNewItem className='business-unit-button-new' onClick={this.openNewForm} />
              </div>
            )}

            <div title={intl.get('filters.filter')}>
              <ButtonIcon
                onClick={this.toggleFilter}
                buttonType='default'
                buttonText={intl.get('filters.filter')}
                buttonIcon={this.hasActiveFilter() ? <IconFilterActive /> : <IconFilterInactive />}
                className={'button-filter'}
              />
            </div>
          </div>
        </div>

        <BusinessUnitList
          data={unities}
          countData={total}
          refreshSearch={this.searchUnities}
          handleEdit={this.openEditForm}
          qtRegsPerPage={this.state.qtRegsPerPage}
          handleDelete={this.openDelete}
          profileAdminOrMasterData={profileAdminOrMasterData}
        />

        {openForm && (
          <BusinessUnitForm
            idEdit={idSelected}
            open={openForm}
            editMode={openEditMode}
            handleClose={this.closeForm}
            handleRefresh={this.refreshSearch}
            handleFeedback={this.showFeedback}
          />
        )}

        <DeleteDialog
          open={openDelete}
          title={intl.get('master-data.managementUnity.unitys.actions.delete')}
          handleClose={this.closeDelete}
          warningMessage={intl.get('master-data.managementUnity.unitys.actions.deleteMessage')}
          handleConfirm={this.deleteBusinessUnit}
        />

        <Sidebar
          visible={showFilterBusinessUnit}
          triggerClose={this.toggleFilter}
          icon={<IconEmpty />}
        >
          <BusinessUnitFilter
            showFilter={showFilterBusinessUnit}
            initialData={filters}
            handleClose={this.applyFilters}
          />
        </Sidebar>

        <SnackBar
          message={deleteErrorDetail}
          open={showFeedback}
          autoHideDuration={3000}
          onRequestClose={this.closeFeedback}
        />
      </div>
    )
  }
}

export default BusinessUnit
